import React, { useEffect, useRef, useState } from "react";
import AtIconUp from "./components/AtIconUp";
import AtIconDown from "./components/AtIconDown";
import AtIconPause from "./components/AtIconPause";
import AtIconPlay from "./components/AtIconPlay";
import AtIconMyRug from "./components/AtIconMyRug";
import AtIconFullScreen from "./components/AtIconFullScreen";
import AtIconExitScreen from "./components/AtIconExitScreen";

import { useSwipeable } from "react-swipeable";

import DesignsList from "./json/DesignsList.json";
import RoomsList from "./json/RoomsList.json";
import clickIcon from "./svg/click.svg";
let stop = false;
const Home = () => {
  const [isPaused, setIsPaused] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isSwipeInProgress, setIsSwipeInProgress] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDesignIndex, setSelectedDesignIndex] = useState(
    Math.floor(Math.random() * Object.keys(DesignsList).length)
  );
  const [selectedVariationList, setSelectedVariationList] = useState(
    DesignsList[selectedDesignIndex].DesignVariations
  );
  const [selectedVariationIndex, setSelectedVariationIndex] = useState(0);

  const [selectedRoomIndex, setSelectedRoomIndex] = useState(
    Math.floor(Math.random() * Object.keys(RoomsList).length)
  );
  const [showModal, setShowModal] = useState(false);
  const [selectedRoomVariationList, setSelectedRoomVariationList] = useState(
    RoomsList[selectedRoomIndex].RoomVariations
  );
  const [selectedRoomVariationIndex, setSelectedRoomVariationIndex] =
    useState(0);
  const designCDN = "https://cdn.explorug.com/website/WovenEdge/Designs";
  const roomCDN = "https://cdn.explorug.com/website/WovenEdge/Rooms";

  useEffect(() => {
    setTimeout(() => {
      setShowModal(true);
    }, [1000]);
  }, []);

  const handleResize = () => {
    if (stop) return;
    stop = true;
    const imageWidth = document
      .getElementsByClassName("movingImage")[0]
      .getBoundingClientRect().width;

    const roomColumnWidth =
      document.getElementsByClassName("roomColumn")[0].clientWidth;
    // Create new keyframes with updated values
    const newKeyframes = `
      @keyframes zoomAndMove {
        0% {
          left: 0px;
        }
        50% {
          left: ${(roomColumnWidth - imageWidth) / 2}px;
          scale: 1.2;
        }
        100% {
          left: ${roomColumnWidth - imageWidth}px;
          scale: 1;
        }
      }
    `;

    // Remove existing style element, if any
    const existingStyleElement = document.getElementById("zoomAndMoveStyle");
    if (existingStyleElement) {
      existingStyleElement.remove();
    }

    // Create a style element with the updated keyframes
    const styleElement = document.createElement("style");
    styleElement.id = "zoomAndMoveStyle";
    styleElement.textContent = newKeyframes;
    document.head.appendChild(styleElement);
  };

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.getElementsByClassName(
        "movingImage"
      )[0].style.animationPlayState = "paused";
      document.getElementsByClassName(
        "movingImage"
      )[1].style.animationPlayState = "paused";
      document
        .getElementsByClassName("roomColumn")[0]
        .requestFullscreen()
        .catch((err) => {
          alert(
            `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
          );
        });
    } else {
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (document.fullscreenElement == null) {
        setIsFullScreen(false);
        document.getElementsByClassName("movingImage")[0].style.animation =
          "zoomAndMove 36s infinite alternate";
        document.getElementsByClassName("movingImage")[1].style.animation =
          "zoomAndMove 36s infinite alternate";
        document.getElementById("image3").classList.remove("fullScreen");
        document.getElementById("image4").classList.remove("fullScreen");
      } else {
        document.getElementById("image3").classList.add("fullScreen");
        document.getElementById("image4").classList.add("fullScreen");
        setIsFullScreen(true);
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    const parentMainDesign = DesignsList[selectedDesignIndex].DesignName;
    const parentMainRoom = RoomsList[selectedRoomIndex];
    const designImage = `${designCDN}/${parentMainDesign}/${parentMainDesign}.jpg`;
    let roomImage;
    if (false) {
      roomImage = `${roomCDN}/${parentMainRoom.RoomName}/${parentMainRoom.RoomVariations[0]}/${parentMainDesign}/${parentMainDesign}-${parentMainRoom.RoomVariations[0]}.jpg`;
    } else {
      roomImage = `${roomCDN}/${parentMainRoom.RoomName}/${parentMainDesign}/${parentMainDesign}-${parentMainRoom.RoomName}.jpg`;
    }
    document.getElementById("image1").src = designImage;
    document.getElementById("image2").src = designImage;
    document.getElementById("image3").src = roomImage;
    document.getElementById("image4").src = roomImage;

    // Cleanup function to remove event listeners when the component is unmounted
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const getVariations = DesignsList[selectedDesignIndex].DesignVariations;
    setSelectedVariationList(getVariations);
    setSelectedVariationIndex(getVariations.length - 1);
  }, [selectedDesignIndex]);
  useEffect(() => {
    const getVariations = RoomsList[selectedRoomIndex].RoomVariations;
    setSelectedRoomVariationList(getVariations);
    setSelectedRoomVariationIndex(0);
  }, [selectedRoomIndex]);

  const changeDesign = (direction) => {
    setIsLoading(true);
    var newcurrentDetailView = selectedDesignIndex;
    newcurrentDetailView =
      direction === "right" ? selectedDesignIndex + 1 : selectedDesignIndex - 1;
    newcurrentDetailView =
      newcurrentDetailView >= DesignsList.length ? 0 : newcurrentDetailView;
    newcurrentDetailView =
      newcurrentDetailView < 0 ? DesignsList.length - 1 : newcurrentDetailView;
    setSelectedDesignIndex(newcurrentDetailView);
    const image1 = document.getElementById("image1");
    const image2 = document.getElementById("image2");
    const image3 = document.getElementById("image3");
    const image4 = document.getElementById("image4");

    const newImage = new Image();
    const newRoomImage = new Image();
    newImage.onload = function () {
      if (image1.classList.contains("hidden")) {
        // Show image1 and hide image2
        image1.src = newImage.src;
        image1.classList.remove("hidden");
        image2.classList.add("hidden");
      } else {
        // Show image2 and hide image1
        image2.src = newImage.src;
        image1.classList.add("hidden");
        image2.classList.remove("hidden");
      }
    };
    newImage.src = `${designCDN}/${DesignsList[newcurrentDetailView].DesignName}/${DesignsList[newcurrentDetailView].DesignName}.jpg`;

    newRoomImage.onload = function () {
      if (image3.classList.contains("hidden")) {
        image3.src = newRoomImage.src;
        image3.classList.remove("hidden");
        image4.classList.add("hidden");
      } else {
        image4.src = newRoomImage.src;
        image3.classList.add("hidden");
        image4.classList.remove("hidden");
      }
      setIsLoading(false);
    };
    const selectedRoom = RoomsList[selectedRoomIndex];
    const parentDesign = DesignsList[newcurrentDetailView].DesignName;
    let roomSrc;
    if (false) {
      roomSrc = `${roomCDN}/${selectedRoom.RoomName}/${selectedRoom.RoomVariations[selectedRoomVariationIndex]}/${parentDesign}/${parentDesign}-${selectedRoom.RoomVariations[selectedRoomVariationIndex]}.jpg`;
    } else {
      roomSrc = `${roomCDN}/${selectedRoom.RoomName}/${parentDesign}/${parentDesign}-${selectedRoom.RoomName}.jpg`;
    }
    newRoomImage.src = roomSrc;
  };

  const changeDesignVariations = (direction) => {
    setIsLoading(true);
    var newcurrentDetailView = selectedVariationIndex;
    newcurrentDetailView =
      direction === "right"
        ? selectedVariationIndex + 1
        : selectedVariationIndex - 1;
    newcurrentDetailView =
      newcurrentDetailView >= selectedVariationList.length
        ? 0
        : newcurrentDetailView;
    newcurrentDetailView =
      newcurrentDetailView < 0
        ? selectedVariationList.length - 1
        : newcurrentDetailView;
    setSelectedVariationIndex(newcurrentDetailView);
    const image1 = document.getElementById("image1");
    const image2 = document.getElementById("image2");
    const image3 = document.getElementById("image3");
    const image4 = document.getElementById("image4");

    const newImage = new Image();
    const newRoomImage = new Image();
    newImage.onload = function () {
      if (image1.classList.contains("hidden")) {
        // Show image1 and hide image2
        image1.src = newImage.src;
        image1.classList.remove("hidden");
        image2.classList.add("hidden");
      } else {
        // Show image2 and hide image1
        image2.src = newImage.src;
        image1.classList.add("hidden");
        image2.classList.remove("hidden");
      }
    };
    newImage.src = `${designCDN}/${DesignsList[selectedDesignIndex].DesignName}/${selectedVariationList[newcurrentDetailView]}`;

    newRoomImage.onload = function () {
      if (image3.classList.contains("hidden")) {
        image3.src = newRoomImage.src;
        image3.classList.remove("hidden");
        image4.classList.add("hidden");
      } else {
        image4.src = newRoomImage.src;
        image3.classList.add("hidden");
        image4.classList.remove("hidden");
      }
      setIsLoading(false);
    };
    const selectedRoom = RoomsList[selectedRoomIndex];
    const parentDesign = DesignsList[selectedDesignIndex].DesignName;
    const selectedDesignWithJpg = selectedVariationList[newcurrentDetailView];
    var selectedDesign = selectedDesignWithJpg.split(".jpg")[0];
    if (selectedDesign.includes("-")) {
      selectedDesign = selectedDesign.split("-").join("_");
    }
    // console.log(
    //   `${roomCDN}/${selectedRoom.RoomName}/${selectedRoom.RoomVariations[newcurrentDetailView]}/${parentDesign}/${selectedDesign}-${selectedRoom.RoomVariations[newcurrentDetailView]}.jpg`
    // );
    let roomSrc;
    if (false) {
      roomSrc = `${roomCDN}/${selectedRoom.RoomName}/${selectedRoom.RoomVariations[selectedRoomVariationIndex]}/${parentDesign}/${selectedDesign}-${selectedRoom.RoomVariations[selectedRoomVariationIndex]}.jpg`;
    } else {
      roomSrc = `${roomCDN}/${selectedRoom.RoomName}/${parentDesign}/${selectedDesign}-${selectedRoom.RoomName}.jpg`;
    }
    newRoomImage.src = roomSrc;
  };

  const changeRoom = (direction) => {
    setIsLoading(true);
    var newcurrentDetailView = selectedRoomIndex;
    newcurrentDetailView =
      direction === "right" ? selectedRoomIndex + 1 : selectedRoomIndex - 1;
    newcurrentDetailView =
      newcurrentDetailView >= RoomsList.length ? 0 : newcurrentDetailView;
    newcurrentDetailView =
      newcurrentDetailView < 0 ? RoomsList.length - 1 : newcurrentDetailView;
    setSelectedRoomIndex(newcurrentDetailView);
    const image3 = document.getElementById("image3");
    const image4 = document.getElementById("image4");

    const newImage = new Image();
    newImage.onload = function () {
      if (image3.classList.contains("hidden")) {
        image3.src = newImage.src;
        image3.classList.remove("hidden");
        image4.classList.add("hidden");
      } else {
        image4.src = newImage.src;
        image3.classList.add("hidden");
        image4.classList.remove("hidden");
      }
      setIsLoading(false);
    };
    const selectedRoom = RoomsList[newcurrentDetailView];
    const parentDesign = DesignsList[selectedDesignIndex].DesignName;
    const selectedDesignWithJpg = selectedVariationList[selectedVariationIndex];
    var selectedDesign = selectedDesignWithJpg.split(".jpg")[0];
    if (selectedDesign.includes("-")) {
      selectedDesign = selectedDesign.split("-").join("_");
    }
    let roomSrc;
    if (false) {
      roomSrc = `${roomCDN}/${selectedRoom.RoomName}/${selectedRoom.RoomVariations[0]}/${parentDesign}/${selectedDesign}-${selectedRoom.RoomVariations[0]}.jpg`;
    } else {
      roomSrc = `${roomCDN}/${selectedRoom.RoomName}/${parentDesign}/${selectedDesign}-${selectedRoom.RoomName}.jpg`;
    }
    newImage.src = roomSrc;
  };

  const changeRoomVariations = (direction) => {
    setIsLoading(true);
    var newcurrentDetailView = selectedRoomVariationIndex;
    newcurrentDetailView =
      direction === "right"
        ? selectedRoomVariationIndex + 1
        : selectedRoomVariationIndex - 1;
    newcurrentDetailView =
      newcurrentDetailView >= selectedRoomVariationList.length
        ? 0
        : newcurrentDetailView;
    newcurrentDetailView =
      newcurrentDetailView < 0
        ? selectedRoomVariationList.length - 1
        : newcurrentDetailView;
    setSelectedRoomVariationIndex(newcurrentDetailView);
    const image3 = document.getElementById("image3");
    const image4 = document.getElementById("image4");

    const newImage = new Image();
    newImage.onload = function () {
      if (image3.classList.contains("hidden")) {
        image3.src = newImage.src;
        image3.classList.remove("hidden");
        image4.classList.add("hidden");
      } else {
        image4.src = newImage.src;
        image3.classList.add("hidden");
        image4.classList.remove("hidden");
      }
      setIsLoading(false);
    };
    const selectedRoom = RoomsList[selectedRoomIndex];
    const parentDesign = DesignsList[selectedDesignIndex].DesignName;
    const selectedDesignWithJpg = selectedVariationList[selectedVariationIndex];
    var selectedDesign = selectedDesignWithJpg.split(".jpg")[0];
    if (selectedDesign.includes("-")) {
      selectedDesign = selectedDesign.split("-").join("_");
    }
    newImage.src = `${roomCDN}/${selectedRoom.RoomName}/${selectedRoom.RoomVariations[newcurrentDetailView]}/${parentDesign}/${selectedDesign}-${selectedRoom.RoomVariations[newcurrentDetailView]}.jpg`;
  };

  useEffect(() => {
    // Attach the event listener when the component mounts
    window.addEventListener("resize", handleResize);

    // Detach the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleExplore = (isScroll = false, designScroll = false) => {
    var variation = `&initvar=`;
    var scroll = ""; //isscroll and designscroll was done for tamariancustom
    if (isScroll) {
      scroll = `&scrollTo=design-view-container`;
    }
    if (designScroll) {
      scroll = `&scrollTo=design-view-container`;
    } else {
      scroll = `&scrollTo=room-view-container`;
    }
    const roomName = RoomsList[selectedRoomIndex].RoomName;
    const designName = DesignsList[selectedDesignIndex].DesignName;
    const roomVariation = selectedRoomVariationList[selectedRoomVariationIndex];
    var designVariation = selectedVariationList[selectedVariationIndex];
    if (designVariation.includes("-")) {
      designVariation = designVariation.split(".jpg")[0].split("-").join(" ");
      variation = variation + designVariation;
    } else {
      variation = "";
    }
    window.open(
      `https://wovenedge.createyourrug.com/?initdesign=Hand%20Tufted%20Designs/${designName}${variation}&initview=${roomName}${scroll}`,
      "_blank"
    );
    // window.open(
    //   `https://myrug.studio/studio?room=${roomName}&type=2D&rug=${designName}&roomvar=${roomVariation}&view=${roomVariation}${variation}`,
    //   "_blank"
    // );
    // const message = {
    //   sourceName: "squareLayout",
    //   roomName,
    //   designName,
    //   roomVariation,
    //   variation,
    // };
    // window.parent.postMessage(message, "*");
  };

  const changeRoomHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (!isSwipeInProgress && !isFullScreen) {
        if (showModal) setShowModal(false);
        setIsSwipeInProgress(true);
        changeRoom("right");
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    onSwipedRight: () => {
      if (!isSwipeInProgress && !isFullScreen) {
        if (showModal) setShowModal(false);
        setIsSwipeInProgress(true);
        changeRoom("left");
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    // onSwipedUp: () => {
    //   if (!isSwipeInProgress && !isFullScreen) {
    //     if (showModal) setShowModal(false);
    //     setIsSwipeInProgress(true);
    //     changeRoomVariations("left");
    //     setTimeout(() => {
    //       setIsSwipeInProgress(false);
    //     }, [1500]);
    //   }
    // },
    // onSwipedDown: () => {
    //   if (!isSwipeInProgress && !isFullScreen) {
    //     if (showModal) setShowModal(false);
    //     setIsSwipeInProgress(true);
    //     changeRoomVariations("right");
    //     setTimeout(() => {
    //       setIsSwipeInProgress(false);
    //     }, [1500]);
    //   }
    // },
    swipeDuration: 2000,
    preventScrollOnSwipe: true,
    trackMouse: false,
  });

  const changeDesignHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (!isSwipeInProgress && !isFullScreen) {
        if (showModal) setShowModal(false);
        setIsSwipeInProgress(true);
        changeDesign("right");
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    onSwipedRight: () => {
      if (!isSwipeInProgress && !isFullScreen) {
        if (showModal) setShowModal(false);
        setIsSwipeInProgress(true);
        changeDesign("left");
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    onSwipedUp: () => {
      if (!isSwipeInProgress && !isFullScreen) {
        if (showModal) setShowModal(false);
        setIsSwipeInProgress(true);
        changeDesignVariations("left");
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    onSwipedDown: () => {
      if (!isSwipeInProgress && !isFullScreen) {
        if (showModal) setShowModal(false);
        setIsSwipeInProgress(true);
        changeDesignVariations("right");
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    swipeDuration: 2000,
    preventScrollOnSwipe: true,
    trackMouse: false,
  });

  var eventClickPending = 0;
  const handleClick = (event, check = true) => {
    // if (showModal) return;
    event.preventDefault();
    const clickedElement = event.target;
    var EVENT_DOUBLE_CLICK_DELAY = 220; // Adjust max delay btw two clicks (ms)
    if (event.detail === 1 && eventClickPending == 0) {
      eventClickPending = setTimeout(function () {
        // Check if the clicked element is an image
        if (clickedElement.className === "roomColumn" || check == false) {
          if (isPaused) {
            document.getElementsByClassName(
              "movingImage"
            )[0].style.animationPlayState = "running";
            document.getElementsByClassName(
              "movingImage"
            )[1].style.animationPlayState = "running";
          } else {
            document.getElementsByClassName(
              "movingImage"
            )[0].style.animationPlayState = "paused";
            document.getElementsByClassName(
              "movingImage"
            )[1].style.animationPlayState = "paused";
          }
          setIsPaused(!isPaused);
        }
      }, EVENT_DOUBLE_CLICK_DELAY);
    } else if (event.detail == 2 && eventClickPending != 0) {
      clearTimeout(eventClickPending);
      eventClickPending = 0;
      handleExplore();
    }
  };
  var eventDesignClickPending = 0;
  const handleDesignClick = (event) => {
    event.preventDefault();
    const clickedElement = event.target;
    var EVENT_DOUBLE_CLICK_DELAY = 220; // Adjust max delay btw two clicks (ms)
    if (event.detail == 1 && eventDesignClickPending == 0) {
      eventDesignClickPending = setTimeout(function () {
        if (clickedElement.tagName === "IMG") {
          // handleExplore(true, false);
          eventDesignClickPending = 0;
        }
      }, EVENT_DOUBLE_CLICK_DELAY);
    } else if (event.detail == 2 && eventDesignClickPending != 0) {
      if (clickedElement.tagName === "IMG") {
        clearTimeout(eventDesignClickPending);
        eventDesignClickPending = 0;
        handleExplore(false, true);
      }
    }
  };

  return (
    <div className="container">
      {showModal && (
        // <div className="modal">

        // </div>
        <div className="modal-content">
          <span className="close" onClick={() => setShowModal(false)}>
            &times;
          </span>
          <h1>DIRECTIONS</h1>
          <table className="infoDiv">
            <tr className="infoText">
              <td>
                <AtIconUp width="45" height="25" />
                <AtIconDown width="45" height="25" />
              </td>
              <td>
                <p>Swipe or Click for design and room variations.</p>
              </td>
            </tr>
            <tr className="infoText">
              <td>
                <AtIconUp width="45" height="25" className="leftRightArrow" />
                <AtIconDown width="45" height="25" className="leftRightArrow" />
              </td>
              <td>
                <p>Swipe or Click to change designs and rooms.</p>
              </td>
            </tr>
            <tr className="infoText">
              <td>
                <div style={{ display: "flex" }}>
                  <button className="iconBox1">
                    <AtIconPlay />
                  </button>
                  <button className="iconBox1">
                    <AtIconPause />
                  </button>
                </div>
              </td>
              <td>
                <p>Single Click or Tap to pause and play.</p>
              </td>
            </tr>
            <tr className="infoText">
              <td>
                <img src={clickIcon} />
              </td>
              <td>
                <p>Double Click or Tap on the scene to explore more.</p>
              </td>
            </tr>
          </table>
          <button
            className="customization"
            onClick={() => handleExplore(false, true)}
          >
            Begin Customization
          </button>
        </div>
      )}
      <div
        className="designColumn"
        style={{ marginRight: "0.5rem", marginBottom: "0.5rem" }}
        {...changeDesignHandlers}
        onClick={(event) => handleDesignClick(event)}
      >
        {/* {showModal && (
          <div className="videoDiv">
            <video height="100%" width="100%" autoPlay muted loop playsInline>
              <source src={loadingDesign} type="video/mp4" />
            </video>
          </div>
        )} */}
        <img className="designImage" id="image1" src="" alt="First Image" />
        <img
          className="designImage hidden"
          id="image2"
          src=""
          alt="Second Image"
        />
        <div className="leftSideButtons">
          <button
            className="iconBox tooltip"
            onClick={() => handleExplore(false, true)}
          >
            <AtIconMyRug />
            <span className="tooltiptext" style={{ marginLeft: "-40px" }}>
              Explore all designs
            </span>
          </button>
        </div>
        {!isLoading && (
          <>
            <div
              className="loadingArrow left"
              onClick={() => changeDesign("left")}
            >
              <AtIconUp />
            </div>
            {(!showModal || window.innerWidth < 800) && (
              <div
                className="loadingArrow right"
                onClick={() => changeDesign("right")}
              >
                <AtIconDown />
              </div>
            )}
            {selectedVariationList.length != 1 && (
              <>
                <div
                  className="loadingArrow up"
                  onClick={() => changeDesignVariations("right")}
                >
                  <AtIconUp />
                </div>
                <div
                  className="loadingArrow down"
                  onClick={() => changeDesignVariations("left")}
                >
                  <AtIconDown />
                </div>
              </>
            )}
          </>
        )}
      </div>

      <div
        className="roomColumn"
        onClick={(event) => handleClick(event, true)}
        {...changeRoomHandlers}
      >
        {/* {showModal && (
          <div className="videoDiv">
            <video height="100%" width="100%" autoPlay muted loop playsInline>
              <source src={loadingRoom} type="video/mp4" />
            </video>
            <span className="closeIcon" onClick={() => setShowModal(false)}>
              &times;
            </span>
          </div>
        )} */}
        <img
          className="movingImage"
          id="image3"
          src=""
          alt="Third Image"
          onLoad={handleResize}
          style={{ userSelect: "none" }}
        />

        <img
          className="movingImage hidden"
          id="image4"
          src=""
          alt="Fourth Image"
          style={{ userSelect: "none" }}
        />
        {!isLoading && (
          <>
            {(!showModal || window.innerWidth < 800) && (
              <div
                className="loadingArrow left"
                onClick={() => changeRoom("left")}
              >
                <AtIconUp />
              </div>
            )}

            <div
              className="loadingArrow right"
              onClick={() => changeRoom("right")}
            >
              <AtIconDown />
            </div>
            {selectedRoomVariationList.length > 1 && (
              <>
                <div
                  className="loadingArrow up"
                  onClick={() => changeRoomVariations("right")}
                >
                  <AtIconUp />
                </div>
                <div
                  className="loadingArrow down"
                  onClick={() => changeRoomVariations("left")}
                >
                  <AtIconDown />
                </div>
              </>
            )}
          </>
        )}

        <div className="rightSideButtons">
          {!isFullScreen && (
            <button
              className="iconBox"
              onClick={(event) => handleClick(event, false)}
              style={{ cursor: "pointer" }}
            >
              {isPaused ? <AtIconPlay /> : <AtIconPause />}
            </button>
          )}
          {/* <button className="iconBox tooltip" onClick={handleExplore}>
            <AtIconMyRug />
            <span className="tooltiptext">Explore</span>
          </button> */}
          <button
            className="iconBox tooltip"
            onClick={() => {
              toggleFullScreen();
            }}
          >
            {isFullScreen ? <AtIconExitScreen /> : <AtIconFullScreen />}
            <span className="tooltiptext" style={{ marginLeft: "-55px" }}>
              {isFullScreen ? "Exit fullscreen" : "Enter fullscreen"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
